<div class="row slides mb-4 justify-content-center">
    <div class="col-12">
        <ngb-carousel *ngIf="images">
            <ng-template ngbSlide>
            <div class="picsum-img-wrapper">
                <img [src]="images[0]" class="bannerimg" alt="Random first slide">
            </div>
            <div class="carousel-caption">
                <!-- <h3>First slide label</h3> -->
                <!-- <p>Nulla vitae elit libero, a pharetra augue mollis interdum.</p> -->
            </div>
            </ng-template>
            <ng-template ngbSlide>
            <div class="picsum-img-wrapper">
                <img [src]="images[1]" class="bannerimg" alt="Random second slide">
            </div>
            <div class="carousel-caption">
                <!-- <h3>Second slide label</h3> -->
                <!-- <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p> -->
            </div>
            </ng-template>
            <ng-template ngbSlide>
            <div class="picsum-img-wrapper">
                <img [src]="images[2]" class="bannerimg" alt="Random third slide">
            </div>
            <div class="carousel-caption">
                <!-- <h3>Third slide label</h3> -->
                <!-- <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> -->
            </div>
            </ng-template>
            <ng-template ngbSlide>
            <div class="picsum-img-wrapper">
                <img [src]="images[3]" class="bannerimg" alt="Random third slide">
            </div>
            <div class="carousel-caption">
                <!-- <h3>Third slide label</h3>
                <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> -->
            </div>
            </ng-template>
            <ng-template ngbSlide>
            <div class="picsum-img-wrapper">
                <img [src]="images[4]" class="bannerimg" alt="Random third slide">
            </div>
            <div class="carousel-caption">
                <!-- <h3>Third slide label</h3>
                <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> -->
            </div>
            </ng-template>
            <ng-template ngbSlide>
            <div class="picsum-img-wrapper">
                <img [src]="images[5]" class="bannerimg" alt="Random third slide">
            </div>
            <div class="carousel-caption">
                <!-- <h3>Third slide label</h3>
                <p>Praesent commodo cursus magna, vel scelerisque nisl consectetur.</p> -->
            </div>
            </ng-template>
        </ngb-carousel>
    </div>
</div>
<div class="row">
    <div class="col-12">
        <mat-grid-list [cols]="cols" rowHeight='380px'>
            <mat-grid-tile *ngFor='let plan of plans' colspan='1' rowspan='1'>
                <mat-card class="example-card mat-elevation-z8">
                    <mat-card-content>
                        <h3 class="text-center bluebar mat-elevation-z8 coolfont">{{plan.payload.doc.data().pname | uppercase}}</h3>
                        <h6 class="text-center">{{plan.payload.doc.data().category}}</h6>
                        <p class="text-center speed">{{plan.payload.doc.data().speed}}</p>
                        <h6 class="text-center">Up to {{plan.payload.doc.data().data}}</h6>
                        <p class="text-center">Post Usage Speed - {{plan.payload.doc.data().exspeed}}</p>
                        <p class="text-center">Rs. <span id="price">{{plan.payload.doc.data().price}}</span>/Month</p>
                        </mat-card-content>
                    <mat-card-actions class="text-center">
                        <button mat-raised-button class="coolbtn" (click)='selectPlan(plan.payload.doc.id)'><mat-icon>add_shopping_cart</mat-icon> SELECT PLAN</button>
                    </mat-card-actions>
                </mat-card>
            </mat-grid-tile>
        </mat-grid-list>
    </div>
</div>